import styled from "@emotion/styled";
import { color } from "../../../styles/color";

export const ConnectText = styled.div`
  z-index: 10;
  display: flex;
  flex-flow: row;
  text-decoration: none;
  &:before {
    content: "";
    position: absolute;
    background-color: ${(props: { link: string }) =>
      props.link === "连线" ? "#8cf08c" : "#fd345c"};
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }
  .linkStatus {
    color: ${(props) => (props.link === "连线" ? "#086208" : "#96112b")};
    margin-left: 0.3rem;
    z-index: 0;
  }
`;
export const Mask = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0%;
  left: 0;
  opacity: ${(props: { show: boolean }) => (props.show ? 1 : 0)};
  visibility: ${(props) => (props.show ? "visible" : "hidden")};
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 99;
  transition: all 0.3s ease-out;
`;
export const OrderContent = styled.div`
  width: 100%;
  max-height: 65vh;
  overflow-y: scroll;
  position: fixed;
  opacity: ${(props: { show: boolean; send: boolean }) => (props.show ? 1 : 0)};
  visibility: ${(props) => (props.show ? "visible" : "hidden")};
  left: 0;
  bottom: 0;
  transform: ${(props) =>
    props.show ? "translate(0,0)" : "translate(0,100vh)"};
  padding: 1.5rem;
  background-color: white;
  z-index: 100;
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
  transition: all 0.3s ease-out;
  scrollbar-width: thin; //Firefox
  scrollbar-color: rgba(0, 0, 0, 0.1) ${color.borderGray};
  @media (min-width: 813px) and (min-height: 520px) {
    width: 50%;
    min-width: 500px;
    max-width: 800px;
    left: 50%;
    border-radius: 0.5rem;
    transform: ${(props) =>
      props.show ? "translate(-50%,-20%)" : "translate(-50%,100%)"};
    &::-webkit-scrollbar {
      width: 8px;
    }
    &::-webkit-scrollbar-track {
      background-color: ${color.borderGray};
      border-radius: 2rem;
    }
    &::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.1);
      border-radius: 2rem;
    }
    &::-webkit-scrollbar-button {
      display: none;
    }
  }
  @media (min-width: 1024px) and (min-height: 768px) {
    height: auto;
    transform: ${(props) =>
      props.show ? "translate(-50%,-25vh)" : "translate(-50%,100%)"};
  }
  .allDevice {
    display: flex;
    flex-flow: column wrap;
    color: ${color.primaryBlue};
    font-size: 1.15rem;
    font-weight: bold;
    @media (min-width: 768px) {
      font-size: 1rem;
    }
    p {
      margin: 0 0 1rem 0;
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .ant-space-item span {
    font-size: 1.15rem !important;
    color: ${color.primaryBlue} !important;
    @media (min-width: 768px) {
      font-size: 1rem !important;
    }
  }
  .dateOutter {
    margin-bottom: 1rem;
    margin-top: 0.5rem;
    width: 100%;
    .ant-picker {
      width: 100%;
    }
    .react-datepicker__input-container {
      position: relative;
    }
    .react-datepicker__input-container input:not([type="range"]) {
      width: 100%;
      border: 1px solid ${color.borderGray};
      border-radius: 0.5rem;
      padding: 0.5rem;
      color: ${color.default};
    }
    .wrapperSelect {
      width: 100%;
      display: flex;
      position: relative;
      &:before {
        content: "";
        position: absolute;
        right: 3rem;
        top: 50%;
        transform: translate(10%, -50%);
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 4px 4px 0 4px;
        border-color: ${color.default} transparent transparent transparent;
      }
    }
    .customInput,
    .timeSelect {
      width: 100%;
      border: 1px solid ${color.borderGray};
      padding: 0.5rem;
      border-radius: 0.5rem;
      background-color: ${(props: { send: boolean }) =>
        props.send === true ? `${color.borderGray}` : "white"};
      color: ${(props) =>
        props.send === true ? `${color.default}` : `${color.primaryBlue}`};
      text-align: left;
    }
    .timeSelect {
      -webkit-appearance: none;
      &:focus-visible {
        outline: none;
      }
    }
    .react-datepicker__close-icon {
      &:after {
        background-color: ${color.markedSecondary};
        position: absolute;
        right: 0.5rem;
        top: 50%;
        transform: translate(0, -50%);
      }
    }
    .react-datepicker {
      font-size: 1.125em;
      border-radius: 0.5rem;
      border-color: transparent;
      box-shadow: 4px 14px 10px 8px ${color.borderGray};
    }
    .react-datepicker__header {
      background-color: white;
    }
    .react-datepicker__header__dropdown {
      padding: 1rem 0;
    }
    .react-datepicker__month {
      margin: 0.4em 1em;
    }
    .react-datepicker__day-name,
    .react-datepicker__day {
      width: 1.9em;
      line-height: 1.9em;
      margin: 0.166em;
    }
    .react-datepicker__current-month {
      display: none;
    }
    .react-datepicker__navigation {
      top: 1.65rem;
    }
    .react-datepicker__navigation--previous {
      border-right-color: #ccc;
      left: 1em;
    }
    .react-datepicker__navigation--next {
      border-left-color: #ccc;
      right: 1em;
    }
    .react-datepicker__month-select,
    .react-datepicker__year-select {
      border: none;
      background-color: transparent;
    }
    .react-datepicker__month-select,
    .react-datepicker__year-select {
      font-size: 1rem;
      font-weight: bolder;
      color: ${color.markedSecondary};
      appearance: none;
      -moz-appearance: none;
      -webkit-appearance: none;
    }
    .react-datepicker__month-select {
      margin-right: 1rem;
    }
    .react-datepicker__day--selected {
      background-color: ${color.markedSecondary};
    }
    .react-datepicker__today-button {
      background-color: white;
      color: ${color.markedSecondary};
    }
  }
  .timeOutter {
    display: flex;
    flex-flow: row nowrap;
    margin-top: 0.5rem;
    justify-content: space-between;
    p {
      margin: auto 0.5rem;
    }
  }
  .btn {
    padding: 0.5rem;
    margin-top: 2rem;
    background-color: ${color.markedSecondary};
    border: none;
    color: white;
    border-radius: 0.2rem;
    cursor: pointer;
    transition: all 0.3s ease-out;
    &:last-of-type {
      margin-top: 1rem;
    }
    @media (min-width: 768px) {
      padding: 0.2rem 0.5rem;
      margin-top: 0;
      margin-left: 1rem;
      &:last-of-type {
        margin-top: 0rem;
      }
    }
  }
  .back {
    background-color: white;
    color: ${color.markedSecondary};
  }
  .btnGroup {
    display: flex;
    flex-flow: column nowrap;
    @media (min-width: 768px) {
      flex-flow: row nowrap;
      justify-content: flex-end;
    }
  }
`;
export const Section = styled.div`
  display: flex;
  flex-flow: column nowrap;
  @media (min-width: 768px) {
    flex-flow: row nowrap;
    align-items: baseline;
    div:nth-last-of-type(1) {
      margin-left: auto;
      margin-right: 0;
    }
  }
  .para {
    order: 2;
    margin: 1rem 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: ${color.primaryBlue};
    font-size: 1.125rem;
    font-weight: bold;
    @media (min-width: 768px) {
      order: 1;
      margin: 0 1rem 1rem 0;
    }
  }
  .btn {
    padding: 0.2rem 0.5rem;
    background-color: white;
    border: 1px solid ${color.markedSecondary};
    color: ${color.markedSecondary};
    border-radius: 0.2rem;
    cursor: pointer;
    transition: all 0.3s ease-out;
    &:hover {
      background-color: ${color.markedSecondary};
      color: white;
    }
  }
  .text {
    color: ${color.primaryBlue};
  }
  .text,
  .btn {
    margin-top: 1rem;
    order: 2;
    margin-right: 0.5rem;
    @media (min-width: 768px) {
      order: 1;
      margin-top: 0;
    }
  }
`;
export const TableOutter = styled.div`
  .unlinkDevice {
    font-size: 1rem;
    margin: -8px;
    padding-bottom: 0.5rem;
    color: ${color.markedSecondary};
    background-color: ${color.secondary};
  }
  .ant-table-container {
    border: 0;
    border-left: 1px solid #f0f0f0;
  }
  th.ant-table-cell {
    background-color: ${color.primaryBlue} !important;
    color: white;
    border-bottom: none;
    &:last-of-type {
      border-top-right-radius: 0.5rem !important;
      border-right: 0 !important;
    }
    &:first-of-type {
      border-top-left-radius: 0.5rem !important;
    }
  }
  td.ant-table-cell {
    border-bottom: 1px solid ${color.primaryBlue};
    border-right: 1px solid ${color.primaryBlue} !important;
    &:first-of-type {
      border-left: 1px solid ${color.primaryBlue};
    }
  }
  .ant-table-container {
    border: 0 !important;
  }
  .ant-table-row {
    &:nth-of-type(odd) {
      //3n+4
      background-color: ${color.secondary};
    }
    &:nth-of-type(even) {
      //3n+4
      background-color: white;
    }
  }
  .ant-table-sticky-scroll-bar {
    position: absolute;
    bottom: 30%;
    height: 10px;
    background-color: rgba(0, 0, 0, 0.5);
  }
  .ant-table-tbody > tr.ant-table-row:hover > td {
    background-color: #ffe0a3;
  }
  .box {
    width: 100%;
    padding: 1rem 5%;
    z-index: 10;
    position: sticky;
    background-color: ${color.secondary};
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    @media (min-width: 768px) {
    }
    .deviceNum {
      font-size: 1rem;
      color: ${color.primaryBlue};
      display: flex;
      flex-flow: row nowrap;
      align-items: baseline;
      p {
        margin-bottom: 0;
      }
      p:last-of-type {
        font-size: 1.5rem;
        font-weight: bolder;
        margin-left: 0.5rem;
      }
    }
    .sendOrder {
      width: 55%;
      outline: none;
      border: none;
      padding: 0.5rem 1rem;
      background-color: ${color.markedSecondary};
      color: white;
      transition: all 0.3s;
      border-radius: 0.5rem;
      font-size: 1.125rem;
      font-weight: 600;
      @media (min-width: 768px) {
        max-width: 150px;
        padding: 0.5rem;
        font-size: 1rem;
      }
      &:disabled {
        background-color: ${color.default};
        color: white;
      }
    }
  }
`;
